/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { lookupRequest } from '../models/lookupRequest';
import type { store } from '../models/store';
import type { vw_store } from '../models/vw_store';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class StoreService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postStoreDataTables({
        requestBody,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        /**
         * The unique identifier of the store
         */
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/store/dataTables',
            query: {
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postStoreLookup({
        requestBody,
    }: {
        requestBody: lookupRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/store/lookup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postStoreGroupedLookup(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/store/groupedLookup',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postStoreBusinessAreaAndStoreLookup(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/store/businessAreaAndStoreLookup',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of Stores
     * @returns vw_store A list of stores
     * @throws ApiError
     */
    public getStores(): CancelablePromise<Array<vw_store>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stores',
        });
    }

    /**
     * Get store by id
     * @returns vw_store The store data
     * @throws ApiError
     */
    public getStore({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_store> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Store not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a store by id
     * @returns any Store deleted successfully
     * @throws ApiError
     */
    public deleteStore({
        id,
    }: {
        /**
         * The store id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/store/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Store not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Store
     * @returns any Store created successfully
     * @throws ApiError
     */
    public postStore({
        requestBody,
    }: {
        requestBody: store,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/store',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Store
     * @returns any Store updated successfully
     * @throws ApiError
     */
    public putStore({
        requestBody,
    }: {
        requestBody: store,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/store',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Store not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Upload a nota image for a store
     * @returns any File uploaded successfully
     * @throws ApiError
     */
    public postStoreUploadNota({
        storeId,
        formData,
    }: {
        /**
         * ID of the store to associate the uploaded nota image with
         */
        storeId: string,
        formData: {
            /**
             * Nota image file (PNG or JPG)
             */
            image: Blob;
        },
    }): CancelablePromise<{
        message?: string;
        file?: {
            fileName?: string;
            filePath?: string;
        };
        record?: store;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/store/upload/nota',
            query: {
                'storeId': storeId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request (e.g., missing file or storeId)`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Stream or download a store's nota image
     * @returns binary Successfully streamed the nota image
     * @throws ApiError
     */
    public getStoreNotaFilepath({
        storeId,
    }: {
        /**
         * ID of the store whose nota image will be streamed
         */
        storeId: string,
    }): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/nota/filepath',
            query: {
                'storeId': storeId,
            },
            errors: {
                400: `Missing or invalid storeId parameter`,
                404: `File not found`,
                500: `Internal server error`,
            },
        });
    }

}
